<!-- 下行日志 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <!-- <el-row class="top-first-line">
        <el-col :span="5">
          <el-form-item label="指令：">
            <el-input v-model="Dform.command" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-col :span="5">
            <el-form-item label="IMEI：">
              <el-input v-model="Dform.titleValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="发送命令：">
              <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="状态：">
              <el-select v-model="Dform.statusValue" placeholder="--请选择--">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col >

  
      </el-row> -->
        <!-- <h1 class="titleStyle">下行日志</h1> -->
      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
          <el-form-item label="指令：">
            <el-input v-model="Dform.command" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-col :span="5">
            <el-form-item label="IMEI：">
              <el-input v-model="Dform.titleValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="上报时间：">
              <el-date-picker
                  v-model="Dform.startTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="To：">
              <el-date-picker
                  v-model="Dform.endTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col >
        <el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
        <!-- <el-button type="primary" class="delete-button" @click="inquiryClick">删除GPS测试数据</el-button> -->
      </el-row>
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         stripe
         :border="true"
         class="table-Style"
         v-loading="loading"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
        
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="command"
            label="指令"
            >
          </el-table-column>
          <el-table-column
            prop="imei"
            label="IMEI"
            >
          </el-table-column>
          <el-table-column
          prop="upData"
          label='下行数据'
          width="500px"
          >
          </el-table-column>
          <el-table-column
            prop="replyData"
            label="返回数据"
            >
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            >
            <template #default="scope">
                 <span v-if="scope.row.status == 1">正常</span>
                 <span v-if="scope.row.status == 4">发送失败</span>
            </template>
          </el-table-column >
          <el-table-column
            prop="time"
            label="发送时间"
            >
          </el-table-column>
        </el-table>
        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>

  </div>
</template>

<script>
import { logManagementUpLog } from '@/assets/api/logapi'

export default {
  components: {

  },
  data() {
      return {
        loading:true,
        Dform: {
          command: '',
          titleValue: '',
          schoolValue:'',
          started:'',
          statusValue:'',
          startTime:'',
          expirationTime:'',
          endTime:''
        },
        options: [
          {
            label: '正常',
            value: '1'
          },
          {
            label: '发送失败',
            value: '4'
          },
        ],
        tableData:[],
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        total: 0
      };
  },
  created() {
    this.logManagementUpLogClick()
  },
  mounted() {

  },
  methods: {
    inquiryClick() {
      // console.log(5555);
      this.pageInfo.page = 1
      this.total = 0
      this.logManagementUpLogClick()
    },
    logManagementUpLogClick () {
      let params = {
        command:this.Dform.command,
        imei:this.Dform.titleValue,
        sendCommand: this.Dform.schoolValue,
        // status: this.Dform.statusValue,
        type: 2,
        startTime: this.Dform.startTime,
        endTime: this.Dform.endTime,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,

      }
      logManagementUpLog(params).then((res)=> {
        this.tableData = res.data.data.list
        this.total = res.data.data.total
        console.log(this.tableData, res.data.data.data,'下行日志');
        this.loading = false
      }).catch((err)=> {
          console.log(err);
      })
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.logManagementUpLogClick()
    },
  },
};
</script>
<style scoped lang="scss">
  .fuzzy-matching-box {
    width: 100%;
    height:  96%;
    .fuzzy-matching-top {
        height: 100px ;
        background-color: #fff;
        border-radius: 15px;
        display: flex;
        align-content: space-around;  
        align-items: center;
    
    .titleStyle{
        margin-left: 40px;
        font-size: 20px;
        font-weight: 700;
        width: 30%;
        } 

      :deep() {
        .el-input--small .el-input__wrapper{
              margin-right: 15px;
              border-radius: 15px
              ;
            }
        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }
        .el-select--small {
            width: 100%
        }
        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;        
          font-weight: 700;  
        }
        .el-form-item {
            width: 109%;
            margin-left: 15px;
          }
        .el-input {
          width: 100%;
          height: 35px;
        }
      }
    .the-second-line {
      margin-top: 15px;
      position: relative;
      .query-button {
        position: absolute;
        right: 35px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
        // background-color: #1BC896;
        border-radius: 15px;
      }
      .delete-button{
        position: absolute;
        left: 950px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
      }
    }
    :deep() {
      .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;  
      }
    }
  }
  .fuzzy-matching-bottom {
    height:85%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 30px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 15px;
    .table-Style{
      font-size: 16px;
      //  border-radius: 15px;
    }
    
    .top-first-line {
      height: 45px;
      line-height: 45px;
        :deep(.tip-button) {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        :deep(.el-button--small) {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      :deep() {
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          font-size: 16px;
          user-select: initial;
          color: black;
        }
         .manipulate {
          color: red;
          margin-right:15px;
          cursor: pointer;
          user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          font-weight: 700;
          text-align: center;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
}
</style>
